export default {
    authUser: {},
};
